import React, { createContext, PropsWithChildren, useMemo, useState } from 'react';
import { StrategyToggle } from '@/types';

import { createUseContext } from '../../../utils/create-use-context';
import { useStrategyLoaderContext } from './strategy-loader';
import { useUserPreferencesLoaderContext } from './user-preferences-loader';

type ContextValue = {
  toggles: StrategyToggle[];
  setTogglesState: (toggles: StrategyToggle[]) => void;
}

export const StrategyToggleContext = createContext<ContextValue | null>(null);
export const useStrategyTogglesContext = createUseContext(StrategyToggleContext);

export function StrategyToggleContextProvider({ children }: PropsWithChildren) {
  const { getStrategyByTopic } = useStrategyLoaderContext();
  const { preferredTopic } = useUserPreferencesLoaderContext();
  const [toggles, setTogglesState] = useState<StrategyToggle[]>(
    () => getStrategyByTopic(preferredTopic).answerStrategyInputs?.toggles ?? []
  );
  const value = useMemo(() => ({ toggles, setTogglesState }), [toggles]);

  return (
    <StrategyToggleContext.Provider value={value}>
      {children}
    </StrategyToggleContext.Provider>
  );
}

